/*
 *   File : skip-history.js
 *   Author : https://evoqins.com
 *   Description : Skip history modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import { Icon } from '../Icon';
import { Loader } from '../Others';

import style from "../../Style/Component/modal.module.scss";

const getStatusStyle = (status) => {
    const normalizedStatus = status?.toLowerCase();

    if (normalizedStatus === "upcoming") {
        return {
            background: "#E7F1FF", //E7F1FF
            color: "#2D5C9E",
        };
    }

    if (normalizedStatus === "skipped") {
        return {
            background: "#FFF5E4",
            color: "#D19533",
        };
    }

    return {
        background: "#dffadf",
        color: "#12b76a",
    };
};

const SkipHistoryModal = (props) => {
    const skipHistory = props.data?.skips || [];

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("skip-history-modal-close");
        button.click();
        if (props.handleClose) {
            props.handleClose();
        }
    };

    return (
        <div className="modal fade"
            id="skip-history-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="skipHistoryModalLabel"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto ${style.e_skip_history_modal}`}>
                <span id='skip-history-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className={`modal-content overflow-hidden border-0 ${style.e_skip_history_modal_content}`}>

                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-12px-lr pt-3 pb-2">
                        <h6 id='skipHistoryModalLabel'
                            className='mb-0 e-text-raisin-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                            Skip history
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-0 px-0 pb-3'>
                        <div className='w-100'>
                            <table className='w-100 mb-0'>
                                <thead>
                                    <tr className='e-bg-lotion '>
                                        <th className='e-text-davys-grey e-primary-font e-font-14 e-font-weight-700 line-height-24px py-2 padding-12px-lr text-start'>
                                            Skip#
                                        </th>
                                        <th className='e-text-davys-grey e-primary-font e-font-14 e-font-weight-700 line-height-24px  py-2 padding-12px-lr text-start'>
                                            Setup date
                                        </th>
                                        <th className='e-text-davys-grey e-primary-font e-font-14 e-font-weight-700 line-height-24px py-2 padding-12px-lr text-start'>
                                            For date
                                        </th>
                                        <th className='e-text-davys-grey e-primary-font e-font-14 e-font-weight-700 line-height-24px py-2 padding-12px-lr text-start'>
                                            Status
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {skipHistory.length > 0 ?
                                        skipHistory.map((item, index) => {
                                            const statusStyle = getStatusStyle(item.skip_status);
                                            return (
                                                <tr key={item.skip || index}
                                                    className='e-border-bottom-1px-platinum-light'>
                                                    <td className='e-text-smoky-black e-alt-font e-font-14 e-font-weight-500 line-height-24px py-2 padding-12px-lr'>
                                                        {item.skip ?? "-"}
                                                    </td>
                                                    <td className='e-text-smoky-black e-alt-font e-font-14 e-font-weight-500 line-height-24px py-2 padding-12px-lr'>
                                                        {item.skip_setup_date || "-"}
                                                    </td>
                                                    <td className='e-text-smoky-black e-alt-font e-font-14 e-font-weight-500 line-height-24px py-2 padding-12px-lr'>
                                                        {item.skip_for_date || "-"}
                                                    </td>
                                                    <td className='py-2 padding-12px-lr d-flex align-items-center justify-content-start'>
                                                        {item.skip_status ?
                                                            <span className='d-inline-flex e-primary-font e-font-10 e-font-weight-500 line-height-12px border-radius-12 py-1 px-2'
                                                                style={statusStyle}>
                                                                {item.skip_status}
                                                            </span>
                                                            :
                                                            "-"
                                                        }
                                                    </td>
                                                </tr>
                                            );
                                        })
                                        :
                                        <tr>
                                            <td colSpan={4}
                                                className='e-text-raisin-black e-primary-font e-font-14 e-font-weight-400 line-height-20px py-3 text-center'>
                                                Skip history not found
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SkipHistoryModal;
